var map = {
	"./belun.png": "bb11",
	"./empty-hsbc.png": "7d88",
	"./empty.png": "bff8",
	"./fiberapi.png": "be49",
	"./hkstp.png": "2417",
	"./jebsen.png": "8b0e",
	"./qfpay.svg": "7700",
	"./spread-it.png": "9b69",
	"./sunstar.png": "a16f",
	"./telkie.png": "6c93"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "66ad";